import { UUID as PBUUID } from "gen/proto/uuid/models_pb"
import { BoolFilter } from "gen/search/service/service_pb"
import { UUID } from "shared-ts/classes/uuid"
import { WebUrl } from "shared-web/lib/webUrl"

export function vendor(id?: PBUUID): WebUrl {
  return {
    pathname: `/pos/vendors/${UUID.idString(id)}`,
  }
}

export function vendors(): WebUrl {
  return {
    pathname: "/pos/vendors",
    query: { status: BoolFilter.TRUE.toString() },
  }
}
